import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'
import { backendForFirebaseUser } from './backendForFirebaseUser'
import { createIdempotencyKey } from './createIdempotencyKey'

export const setCurrentFriend = async (
    profileId,
    shouldAdd,
    idempotencyKey = createIdempotencyKey('friend')
) => {
    const normalizedProfileId = Number(profileId)
    if (!Number.isSafeInteger(normalizedProfileId) || normalizedProfileId < 0) {
        throw new TypeError('Friend profile ID must be a non-negative integer')
    }

    const user = getAuth(app).currentUser
    const backend = backendForFirebaseUser(user)
    if (backend) {
        return shouldAdd
            ? backend.addFriend(normalizedProfileId, idempotencyKey)
            : backend.removeFriend(normalizedProfileId, idempotencyKey)
    }

    if (!user?.uid) {
        throw new Error('Firebase authentication is required')
    }

    const { arrayRemove, arrayUnion, db, doc, updateDoc } =
        await loadLegacyFirestore()
    await updateDoc(doc(db, 'Auth', user.uid), {
        friends: shouldAdd
            ? arrayUnion(normalizedProfileId)
            : arrayRemove(normalizedProfileId),
    })
    return { changed: true }
}
